import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { faUserSecret } from '@fortawesome/pro-light-svg-icons';
import { SharedModule } from '../../shared/shared.module';
import { TranslocoPipe } from '@jsverse/transloco';
import { MembershipService } from '@app/core/services/membership.service';
import { AppConfigService } from '@app/core/services/config.service';
import { formValueLabelPair } from '@app/shared/utils/pipe.functions';
import { LanguagePickerModalComponent } from '@app/shared/components/language-picker-modal/language-picker-modal.component';
import { TranslationSandbox } from '@app/core/sandboxes/translation.sandbox';
import { CultureInfo } from '@app/core/types/config/config.types';
import { ButtonComponent } from '@app/shared/ui/button/button.component';

@Component({
  selector: 'c-impersonation-banner',
  imports: [SharedModule, TranslocoPipe, ButtonComponent],
  templateUrl: './impersonation-banner.component.html',
  styleUrl: './impersonation-banner.component.scss',
})
export class ImpersonationBannerComponent {
  private readonly membershipService = inject(MembershipService);
  private readonly configService = inject(AppConfigService);
  private readonly modalController = inject(ModalController);
  private readonly translationSandbox = inject(TranslationSandbox);

  cultureInfos: CultureInfo[] = this.configService.cultureInfos;
  appLanguages = this.configService.cultureInfos.map((cultureInfo) => 
    formValueLabelPair(cultureInfo.cultureCode, cultureInfo.languageNativeName));
  selectedLanguage = this.translationSandbox.applicationLanguage;

  faUserSecret = faUserSecret;

  externalId$ = this.membershipService.getExternalId();
  userProfile$ = this.membershipService.getUserProfile();

  async openLanguagePicker(): Promise<void> {
    const modal = await this.modalController.create({
      component: LanguagePickerModalComponent,
      componentProps: {
        languages: this.cultureInfos,
        close: (language: CultureInfo) => modal.dismiss(language),
      },
      cssClass: ['auto-height-modal'],
      breakpoints: [0, 1],
      initialBreakpoint: 1,
      handle: false
    });
    modal.present();
    modal.onDidDismiss().then((data) => {
      if (data.data) {
        this.translationSandbox.changeLanguage(data.data.cultureCode);
        this.translationSandbox.setApplicationLanguage(this.cultureInfos.find(culture => culture.cultureCode === data.data.cultureCode) as CultureInfo);
      }
    });
  }
}
